import type { Params } from '@vimcar/mvvm/linkViewModel'
import type { Transitioner } from '#components/TransitionProvider'

import * as mobx from 'mobx'
import PT from 'prop-types'

import type { LinkGroup } from '../../models/Nodes/LinkGroup'
import type { NodeLink } from '../../models/Nodes/NodeLink'

export type Props = {
  linkGroup?: LinkGroup | null
  onChange?: (string) => void
}

export type ViewModel = {
  _searchTerm: string
  searchTerm: string
  links: Array<NodeLink>
  handleSearchFormChange: (args: { term: string }) => void
}

type Context = {
  transitioner: Transitioner
}

const mkViewModel = (
  { disposer, registerAutorun }: Params,
  props: Props,
  { transitioner }: Context,
): ViewModel => {
  const vm = mobx.observable({
    _searchTerm: '',
    get links() {
      if (!props.linkGroup || !vm.searchTerm) return []
      return props.linkGroup.links.filter((option) =>
        option.matches(vm._searchTerm),
      )
    },
    get searchTerm() {
      return vm._searchTerm && vm._searchTerm.length >= 3 ? vm._searchTerm : ''
    },
    handleLinkClick: (link) => () => {
      transitioner.openExternal(link.externalLink)
    },
    handleSearchFormChange: mobx.action(({ term }) => {
      vm._searchTerm = term
      if (props.onChange) props.onChange(vm.searchTerm)
    }),
  })

  return vm
}

mkViewModel.contextTypes = {
  transitioner: PT.object.isRequired,
}

export default mkViewModel
